// Every reducer sees every action, so these values carry a "PMS_" prefix to
// keep them apart from Everou's LOCATION_ACTION_TYPES: Rental also loads the
// Everou locations (the header's code entry), and a shared
// "LOCATIONS_LIST_SUCCESS" made each store swallow the other's list.
export const PMS_LOCATIONS_ACTION_TYPES = {
    LOCATIONS_CHANGE_FILTER: "PMS_LOCATIONS_CHANGE_FILTER",
    LOCATIONS_LIST_SUCCESS: "PMS_LOCATIONS_LIST_SUCCESS",
    LOCATIONS_LIST_FAILURE: "PMS_LOCATIONS_LIST_FAILURE",
    LOCATIONS_SET_REQUESTING_STATUS: "PMS_LOCATIONS_SET_REQUESTING_STATUS",
    LOCATIONS_CHANGE_OFFSET: "PMS_LOCATIONS_CHANGE_OFFSET",
    LOCATIONS_SELECT: "PMS_LOCATIONS_SELECT",
    LOCATION_INFO_GET_SUCCESS: "PMS_LOCATION_INFO_GET_SUCCESS",
    LOCATION_INFO_UPDATE_LOCALLY: "PMS_LOCATION_INFO_UPDATE_LOCALLY",
    LOCATION_CUSTOMIZATION_GET_SUCCESS: "PMS_LOCATION_CUSTOMIZATION_GET_SUCCESS",
    LOCATION_CUSTOMIZATION_IS_UPLOADING_SET: "PMS_LOCATION_CUSTOMIZATION_IS_UPLOADING_SET",
    LOCATION_CREATE_LOCAL_RESERVATION: "PMS_LOCATION_CREATE_LOCAL_RESERVATION",
    CREATE_LOCAL_RESERVATION: "PMS_CREATE_LOCAL_RESERVATION",
    DELETE_LOCAL_RESERVATION: "PMS_DELETE_LOCAL_RESERVATION",
    RESERVATION_UPDATE_NEW_DRAFT_LOCALLY: "PMS_RESERVATION_UPDATE_NEW_DRAFT_LOCALLY",
    RESERVATION_UPDATE_SELECTED_LOCALLY: "PMS_RESERVATION_UPDATE_SELECTED_LOCALLY",
}
